import httpClient from '../httpClient';


const createUnitPerson = async (data) => {
  return await httpClient.post(`unit_person/`, data);
};

const createUnitPersonMassive = async (data) => {
  return await httpClient.post(`unit_person/massive/`, data);
};

const getUnitPerson = async (id) => {
  return await httpClient.get(`unit_person/${id}/`);
};

const updateUnitPerson = async (id, data) => {
  return await httpClient.put(`unit_person/${id}/`, data);
};

const deleteUnitPerson = async (id) => {
  return await httpClient.delete(`unit_person/${id}/`);
};

const queryUnitPerson = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/unit_person/?page[number]=${page}&page[size]=${pageSize}&${query}${sortBy}${searchBy}`,
  );
};

const queryUnitPersonPersons = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/unit_person/persons?page[number]=${page}&page[size]=${pageSize}&${query}${sortBy}${searchBy}`,
  );
};

const queryUnitPersonUnits = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/unit_person/units?page[number]=${page}&page[size]=${pageSize}&${query}${sortBy}${searchBy}`,
  );
};

export {
  createUnitPerson,
  createUnitPersonMassive,
  getUnitPerson,
  updateUnitPerson,
  queryUnitPerson,
  queryUnitPersonPersons,
  queryUnitPersonUnits,
  deleteUnitPerson,
}
